module.exports = __webpack_public_path__ + "img/holysee.e3e23e2d.svg";